import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Import axios để gọi API
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Cookies from 'js-cookie';
import { publicIpv4 } from "public-ip";
import { useTranslation } from 'react-i18next';
import useLanguage from '../../Hooks/useLanguage';
const AddTicket = () => {
    const [priority, setPriority] = useState(1);
    const [content, setContent] = useState('');
    const [subject, setSubject] = useState('');
    const [department, setDepartment] = useState('');
    const [departments, setDepartments] = useState([]);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [ipAddress, setIpAddress] = useState(null);
    useLanguage();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const token = Cookies.get("Token");
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/departments`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setDepartments(response.data);
            } catch (err) {
                setError('Không thể tải danh sách phòng ban');
            }
        };
        fetchDepartments();
    }, []);
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!department) {
            setError('Vui lòng chọn phòng ban!');
            return;
        }

        const formData = {
            subject: subject,
            message: content,
            priority: priority,
            department: department,
            ip_address: ipAddress,
        };

        try {
            const token = Cookies.get("Token");
            await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/tickets`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            setSuccess('Tạo ticket thành công!');
            setError(null);
        } catch (err) {
            setError(err.response ? err.response.data : 'Có lỗi xảy ra!');
            setSuccess(null);
        }
    };

    return (
        <div className="container mt-4">
            <h3>{t("Add new ticket")}</h3>
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>{t("Title")}</label>
                    <input
                        type="text"
                        name="title"
                        className="form-control"
                        required
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label>{t("Priority level")}</label>
                    <select
                        className="form-control"
                        value={priority}
                        onChange={(e) => setPriority(e.target.value)}
                    >
                        <option value="1">{t("Low")}</option>
                        <option value="2">{t("Medium")}</option>
                        <option value="3">{t("High")}</option>
                    </select>
                </div>
                <div className="form-group">
                    <label>{t("Departments")}</label>
                    <select
                        className={`form-control ${error && !department ? 'is-invalid' : ''}`}
                        value={department}
                        onChange={(e) => setDepartment(e.target.value)}
                    >
                        <option value="">{t("Choose Department")}</option>
                        {departments.map((dept) => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                        ))}
                    </select>
                    {error && !department && <div className="invalid-feedback">Vui lòng chọn phòng ban!</div>}
                </div>

                <div className="form-group">
                    <label>{t("Content")}</label>
                    <CKEditor
                        editor={ClassicEditor}
                        data={content}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setContent(data);
                        }}
                        config={{
                            height: 500,
                        }}
                    />
                </div>

                <button type="submit" className="btn btn-primary mt-3">{t("Submit")}</button>
            </form>
        </div>
    );
};

export default AddTicket;
